/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ServicePointModel } from '@/api/service-point/service-point/service-point.model';
import SelectPickUp from '@/modules/service-point/components/select-pick-up/select-pick-up.component.vue';
import UserMenu from '@/ui/components/user-menu/user-menu.component.vue';
import { IUser } from '@/ui/components/user-menu/user-menu.types';

/**
 * Component.
 */
@Component({
  components: { UserMenu, 'select-pick-up': SelectPickUp },
  name: 'headpiece-component'
})
export default class extends Vue {
  /**
   * Property `identifier`.
   */
  @Prop()
  identifier: string;

  /**
   * Property `pickUpPoints`.
   */
  @Prop({ default: () => [], type: Array })
  pickUpPoints: ServicePointModel[];

  /**
   * Property `currentPickUpPoint`.
   */
  @Prop({ default: null, type: Object })
  currentPickUpPoint: ServicePointModel;

  /**
   * Property `user`.
   */
  @Prop({ default: null, type: Object })
  user: IUser;

  /**
   * Getter `menuActions`.
   */
  get menuActions(): {
    event: string;
    icon: string;
    label: string;
  }[] {
    const { prozisUserId: userId } = this.user || {};
    const { owner } = this.currentPickUpPoint || {};
    const { prozisUserId } = owner || {};

    let actions = [];
    if (userId === prozisUserId) {
      actions = [
        {
          event: 'return-home',
          icon: 'mdi-home',
          label: this.i18n('MAIN.ACTIONS.HOME')
        },
        {
          event: 'users-list',
          icon: 'mdi-account-multiple',
          label: this.i18n('MAIN.ACTIONS.USERS')
        }
      ];
    }

    return actions;
  }

  /**
   * Getter `currentPickUpPointId`.
   */
  get currentPickUpPointId() {
    const { id } = (this.currentPickUpPoint as any) || {};

    return id;
  }

  /**
   * Getter `userAvatarSize`.
   */
  get userAvatarSize() {
    return this.$now.layout.height.smAndDown ? '32' : '40';
  }

  /**
   * Handle selected new pick up point.
   */
  handleSelectedNewPickUpPoint({
    pickUpPoint
  }: {
    pickUpPoint: ServicePointModel;
  }) {
    this.$emit('selected-pick-up-point', { pickUpPoint });
  }

  /**
   * Handle return home.
   */
  handleReturnHome() {
    this.$router.push({
      name: 'ServicePointHome'
    });
  }

  /**
   * Handle users list.
   */
  handleViewUsersList() {
    this.$router.push({
      name: 'ServicePointUsersList'
    });
  }

  /**
   * Handle load more.
   */
  handleLoadMore(data) {
    this.$emit('load-more-pickup-points', data);
  }

  /**
   * Handle logout.
   */
  async handleLogout() {
    this.$emit('logout');
  }
}
